import { Button, Menu, Text } from "@mantine/core";
import React from "react";
import { FaChevronDown } from "react-icons/fa";
import { FaDiagramProject, FaList } from "react-icons/fa6";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { copyDevicesFromStandardRoomToSelectedRoomThunk } from "../../DesignTab/devices/deviceThunks";
import { selectDevicesExistInRoom } from "../../DesignTab/devices/deviceSlice";
import { selectHttpSingleRoomFull } from "../../Room/httpRoomSelectors";
import PipeSystemsCopyModal from "../../McBim/PipeSystemsCopyModal";
import { setPipeSystemsCopyModalOpenInRedux } from "../../DesignTab/designSlice";

const CopyFromStandardRoomMenu: React.FC = () => {
  const dispatch = useAppDispatch();
  const singleRoom = useAppSelector(selectHttpSingleRoomFull);

  const roomHasDevices = useAppSelector(selectDevicesExistInRoom);
  const isPipeCopyAvailable = import.meta.env.DEV;

  const isLocked = singleRoom?.multiplacerCeilingDevicesLocked?.bool === true;
  const hasStandardRoom = singleRoom?.rfpMalRom != null && singleRoom?.rfpMalRom !== "";

  const openPipeModal = () => {
    dispatch(setPipeSystemsCopyModalOpenInRedux(true));
  };

  if (!hasStandardRoom) {
    return null;
  }

  return (
    <>
      <Menu shadow="md" width={320} position="bottom-start" withinPortal>
        <Menu.Target>
          <Button
            h={30}
            size="xs"
            variant="outline"
            rightSection={<FaChevronDown size={10} />}
            disabled={isLocked}
            radius="md"
          >
            Kopier fra standardrom
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Label>Standardrom</Menu.Label>
          <Menu.Item
            leftSection={<FaList size={14} />}
            disabled={roomHasDevices}
            onClick={() => dispatch(copyDevicesFromStandardRoomToSelectedRoomThunk())}
          >
            Kopier komponenter
          </Menu.Item>
          {roomHasDevices && (
            <Text size="xs" c="dimmed" px="sm" pb={6}>
              Kan ikke kopiere komponenter fordi rommet allerede har komponenter.
            </Text>
          )}
          <Menu.Item
            leftSection={<FaDiagramProject size={14} />}
            onClick={openPipeModal}
            disabled={!isPipeCopyAvailable}
          >
            {isPipeCopyAvailable ? "Kopier rør/kanaler" : "Kopier rør/kanaler (upcoming)"}
          </Menu.Item>
          {!isPipeCopyAvailable && (
            <Text size="xs" c="dimmed" px="sm" pb={6}>
              Rørkopiering er upcoming og blir tilgjengelig senere.
            </Text>
          )}
        </Menu.Dropdown>
      </Menu>

      <PipeSystemsCopyModal />
    </>
  );
};

export default CopyFromStandardRoomMenu;
